module.exports = __webpack_public_path__ + "static/media/hero1.9f08619c.png";